module.exports = __webpack_public_path__ + "img/359-d31e2c.png";